/**
 * 人が画面を触っているか（#123 の 2b、docs/48 §5）。
 * 最後に触ってから5分たつと、API に x-gb-idle: 1 を付ける＝利用状況に数えない
 * （開いたままの画面の読み直し＝バッジ・外注見積の読み取りの待ちが「使った日」「利用時間」をふくらませないため。apps/api/src/core/usage.ts）。
 * 触ったとみなすのは キー・クリック・タッチ・ホイール・画面に戻ったとき。ページを開いた時も触ったとみなす
 */
export const IDLE_MS = 5 * 60_000;

let last = Date.now();
const touch = () => {
  last = Date.now();
};

if (typeof window !== "undefined") {
  for (const ev of ["pointerdown", "keydown", "wheel", "touchstart"] as const) window.addEventListener(ev, touch, { capture: true, passive: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") touch();
  });
}

/** 5分 触っていなければ { "x-gb-idle": "1" }、触っていれば空 */
export function idleHeaders(now = Date.now()): Record<string, string> {
  return now - last >= IDLE_MS ? { "x-gb-idle": "1" } : {};
}
